import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import styled from 'styled-components';
import t from 'common/i18n';
import Button from 'root/components/Button';
import MenuButton from 'root/components/MenuButton/MenuButton';
import SvgIcon from '../SvgIcon';
import { selectNotification } from '../../selectors';
import bindActions, { types as ats } from '../../actions';
import SVG_ICONS from '~/assets/icons/icons';

const StyledToast = styled.div.attrs({ className: 'Notification absolute center left-0 right-0 w-100 z-999' })({
  top: 52,
});

const StyledToastInner = styled.div.attrs({
  className: 'overflow-hidden ma4 flex items-center justify-between ba bg-window bc-window-border bg-window-c relative z-1',
})({
  padding: '14px 16px',
  boxShadow: '0 6px 15px rgba(0,0,0,0.24)',
});

const StyledMessage = styled.div.attrs({ className: 'flex items-center f5' })``;

const StyledClose = styled.div.attrs({ className: 'ml4 flex items-center' })``;

const StyledToastUnderlay = styled.div.attrs({ className: 'Notification-underlay fixed top-0 right-0 bottom-0 left-0' })({
  background: 'rgba(0, 0, 0, 0.5)',
});

export const Notification = (props) =>
  props.id && props.text ? (
    <StyledToast data-test="notification" className={cx(props.width ? `w-${props.width}-ns` : 'w-50-ns')}>
      {props.underlay && <StyledToastUnderlay />}
      {props.id && (
        <StyledToastInner>
          <StyledMessage>
            {props.type === 'success' && <SvgIcon className="mr3 flex-shrink-0" size="xl2" path={SVG_ICONS.CHECKED} colorName="complete" />}
            {!props.type && (
              <SvgIcon className="mr3 flex-shrink-0" size="xl2" path={SVG_ICONS.ERROR} colorName="error" dataTest="notification-icon-error" />
            )}
            {props.text && t(props.text)}
          </StyledMessage>
          <div className="flex items-center">
            {props.actions && props.actions.length && (
              <StyledClose>
                {props.actions.map((action) => (
                  <Button
                    key={action.label}
                    onClick={() => {
                      if (action.onClick) {
                        action.onClick();
                      } else {
                        props[ats.CLEAR_NOTIFICATION]({ id: props.id });
                      }
                    }}
                    colorName={action.color}
                    textColorName={action.textColor}
                    text={t(action.label)}
                    fontSize={12}
                  />
                ))}
              </StyledClose>
            )}
            <StyledClose>
              <MenuButton iconSize="sm" icon={SVG_ICONS.CLOSE} onClick={() => props[ats.CLEAR_NOTIFICATION]({ id: props.id })} />
            </StyledClose>
          </div>
        </StyledToastInner>
      )}
    </StyledToast>
  ) : null;

// const selectProps = selectNotification; //flow is so stupid!

// const mapStateToProps = (state) => ({
//     palette: selectPalette(state),
// });

export default connect(selectNotification, bindActions)(Notification);
